(function(){
  'use strict';
  var LKEY='vq-lang';

  function syncLangUrl(l){
    try{
      var url=new URL(window.location.href);
      if(l==='ar'){url.searchParams.set('lang','ar');}
      else{url.searchParams.delete('lang');}
      window.history.replaceState(window.history.state,'',url.toString());
    }catch(e){}
  }

  function applyLang(l){
    var ar=l==='ar';
    var en=l==='en';
    document.documentElement.lang= ar?'ar':(en?'en':'fr');
    document.documentElement.dir= ar?'rtl':'ltr';

    document.querySelectorAll('[data-ar]').forEach(function(el){
      if(!el.getAttribute('data-fr')){el.setAttribute('data-fr',el.textContent.trim());}
      if(ar){ el.textContent=el.getAttribute('data-ar'); }
      else if(en && el.getAttribute('data-en')){ el.textContent=el.getAttribute('data-en'); }
      else { el.textContent=el.getAttribute('data-fr'); }
    });
    document.querySelectorAll('[data-ar-ph]').forEach(function(el){
      if(!el.getAttribute('data-fr-ph')){el.setAttribute('data-fr-ph',el.getAttribute('placeholder')||'');}
      if(ar){ el.setAttribute('placeholder',el.getAttribute('data-ar-ph')); }
      else if(en && el.getAttribute('data-en-ph')){ el.setAttribute('placeholder',el.getAttribute('data-en-ph')); }
      else { el.setAttribute('placeholder',el.getAttribute('data-fr-ph')); }
    });
    document.querySelectorAll('[data-ar-label]').forEach(function(el){
      if(!el.getAttribute('data-fr-label')){el.setAttribute('data-fr-label',el.getAttribute('aria-label')||'');}
      if(ar){ el.setAttribute('aria-label',el.getAttribute('data-ar-label')); }
      else if(en && el.getAttribute('data-en-label')){ el.setAttribute('aria-label',el.getAttribute('data-en-label')); }
      else { el.setAttribute('aria-label',el.getAttribute('data-fr-label')); }
    });
    document.querySelectorAll('.vq-i18n').forEach(function(el){
      var lang = el.getAttribute('data-lang');
      var show = ar ? (lang==='ar') : (en ? (lang==='en' || (lang==='fr' && !document.querySelector('.vq-i18n[data-lang="en"]'))) : (lang==='fr'));
      el.hidden = !show;
    });
    var btn=document.getElementById('VqLangBtn');
    if(btn){btn.textContent=ar?'FR':(en?'FR':'عربية');}
    try{localStorage.setItem(LKEY,l);}catch(e){}
    syncLangUrl(l);
    if(window.vqAnnounceRefresh)window.vqAnnounceRefresh();
  }

  var saved='fr';
  try{saved=localStorage.getItem(LKEY)||'fr';}catch(e){}
  applyLang(saved==='ar'?'ar':(saved==='en'?'en':'fr'));

  var btn=document.getElementById('VqLangBtn');
  if(btn){btn.addEventListener('click',function(){applyLang(document.documentElement.lang==='ar'?'fr':'ar');});}

  /* Announcement: 2 phrases, 5s, fade */
  var ann=document.getElementById('VqAnnounce');
  if(ann){
    var idx=0;
    function msgs(){
      var ar=document.documentElement.lang==='ar';
      return [ar?ann.getAttribute('data-m1-ar'):ann.getAttribute('data-m1'),
              ar?ann.getAttribute('data-m2-ar'):ann.getAttribute('data-m2')];
    }
    window.vqAnnounceRefresh=function(){ann.textContent=msgs()[idx];};
    ann.textContent=msgs()[0];ann.classList.add('in');
    setInterval(function(){
      ann.classList.remove('in');
      setTimeout(function(){idx=(idx+1)%2;ann.textContent=msgs()[idx];ann.classList.add('in');},800);
    },5000);
  }

  /* Scroll reveal */
  var els=document.querySelectorAll('.vq-card,.vq-trust__item,.vq-24h__card,.vq-testi__card,.vq-sec__head,.vq-banner,.vq-colcard,.vq-cert');
  if('IntersectionObserver' in window&&els.length&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vq-in');io.unobserve(e.target);}});
    },{threshold:0.01,rootMargin:'120px 0px'});
    els.forEach(function(el){el.classList.add('vq-reveal');io.observe(el);});
  }

  /* ===== COD MODAL (style Veelena) ===== */
  var modal=document.getElementById('VqCodModal');
  function openModal(){
    if(!modal)return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var f=modal.querySelector('input:not([type=hidden])');
    if(f){setTimeout(function(){f.focus();},350);}
  }
  function closeModal(){
    if(!modal)return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }
  var openBtn=document.querySelectorAll('#VqRevealCod, .vq-cta-open');
  openBtn.forEach(function(b){b.addEventListener('click',openModal);});
  if(modal){
    modal.querySelectorAll('[data-vq-modal-close]').forEach(function(el){
      el.addEventListener('click',closeModal);
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});
  }

  /* « 1 299,00 MAD » -> 1299.00 . On retire les separateurs de milliers puis on
     normalise la virgule decimale marocaine en point. */
  function vqMoneyToNumber(txt){
    if(!txt)return 0;
    var t=String(txt).replace(/[^0-9.,]/g,'');
    if(t.indexOf(',')>-1&&t.indexOf('.')>-1){ t=t.replace(/\./g,'').replace(',','.'); }
    else if(t.indexOf(',')>-1){ t=t.replace(/,(?=\d{3}\b)/g,'').replace(',','.'); }
    var n=parseFloat(t);
    return isNaN(n)?0:n;
  }
  window.vqMoneyToNumber=vqMoneyToNumber;

  function vqDigits(v){ return (v||'').replace(/\D/g,''); }

  /* ===== Mise en conformite du formulaire au chargement =====
     Tant que la section produit n'est pas migree vers le snippet
     'vq-cod-fields', on corrige ici ce qui bloquait reellement :

     1. L'attribut pattern='[0-9+ ]{9,15}' sur le telephone. Il faisait echouer
        la validation HTML5 en silence sur un tiret, un point ou un +212 espace :
        l'evenement submit ne partait jamais, donc ni webhook Make ni Purchase.
        On le retire ; la validation se fait en JS, avec un message lisible.
     2. Le message d'erreur, absent du markup actuel : on l'insere sous le champ.
     3. Les champs caches de prix, absents du markup actuel : ce sont de simples
        porteurs de donnees pour le webhook et le pixel, on les cree ici. */
  (function normaliseCodForms(){
    ['VqCodForm','VqCartCodForm'].forEach(function(id){
      var f=document.getElementById(id);
      if(!f)return;

      var ph=f.querySelector('[data-vq-cod-phone]');
      if(ph){
        ph.removeAttribute('pattern');
        ph.setAttribute('inputmode','numeric');
        ph.setAttribute('autocomplete','tel');
        if(!f.querySelector('[data-vq-phone-err]')){
          var err=document.createElement('p');
          err.className='vq-field__err';
          err.setAttribute('data-vq-phone-err','');
          err.hidden=true;
          err.setAttribute('data-ar','دخّل رقم صحيح — 9 أرقام على الأقل');
          err.textContent='Entrez un numéro valide — au moins 9 chiffres.';
          (ph.parentNode||f).appendChild(err);
        }
      }

      [['codTotal','contact[PrixTotal]'],['codUnit','contact[PrixUnitaire]']].forEach(function(pair){
        if(document.getElementById(pair[0]))return;
        var i=document.createElement('input');
        i.type='hidden'; i.id=pair[0]; i.name=pair[1]; i.value='';
        f.appendChild(i);
      });
    });

    /* Valeur de depart : le prix affiche dans le modal, ou le palier actif. */
    var active=document.querySelector('.vq-offer.active .vq-offer__now');
    var shown=document.querySelector('.vq-modal__pprice');
    var txt=(active&&active.textContent)||(shown&&shown.textContent)||'';
    var n=vqMoneyToNumber(txt);
    var t=document.getElementById('codTotal'), u=document.getElementById('codUnit');
    var q=document.getElementById('codQty');
    var qn=q?(parseInt(q.value,10)||1):1;
    if(t&&n>0&&!t.value)t.value=n.toFixed(2);
    if(u&&n>0&&!u.value)u.value=(n/qn).toFixed(2);
  })();

  /* ===== Validation du telephone, en phase de CAPTURE =====
     theme.liquid accroche le pixel Purchase et le webhook Make sur 'submit' en
     capture au niveau du document. Ce handler est enregistre AVANT eux (ce
     fichier est charge avant les scripts inline), donc un numero invalide est
     arrete ici : ni commande fantome dans Make, ni faux Purchase. */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||(f.id!=='VqCodForm'&&f.id!=='VqCartCodForm'))return;
    var ph=f.querySelector('[data-vq-cod-phone]');
    if(!ph)return;
    var err=f.querySelector('[data-vq-phone-err]');
    var d=vqDigits(ph.value);
    if(d.length<9){
      e.preventDefault();
      /* stopImmediatePropagation et non stopPropagation : les handlers du pixel
         et du webhook Make sont enregistres sur le MEME noeud (document, phase
         capture). stopPropagation ne bloque que les autres noeuds ; les voisins
         sur le meme noeud continuent de s'executer. Verifie en conditions
         reelles : avec stopPropagation, un numero invalide creait quand meme
         une commande dans Make. */
      e.stopImmediatePropagation();
      if(err){err.hidden=false;}
      ph.setAttribute('aria-invalid','true');
      try{ph.focus({preventScroll:false});}catch(err2){ph.focus();}
      return;
    }
    if(err){err.hidden=true;}
    ph.removeAttribute('aria-invalid');
    ph.value=d;
  },true);

  /* COD submit: etat de chargement, avec restauration.
     Avant, le bouton passait en disabled et n'etait JAMAIS reactive : sur un
     POST lent ou en echec, le client avait un bouton mort. */
  var cform=document.getElementById('VqCodForm');
  if(cform){
    cform.addEventListener('submit',function(){
      var sb=cform.querySelector('[type=submit]');
      if(!sb)return;
      var original=sb.textContent;
      sb.disabled=true;
      sb.textContent=document.documentElement.lang==='ar'?'جاري الإرسال…':(document.documentElement.lang==='en'?'Sending…':'Envoi en cours…');
      setTimeout(function(){sb.disabled=false;sb.textContent=original;},8000);
    });
    if(cform.querySelector('.vq-thankyou')){
      openModal();
    }
  }

  /* iOS Safari ne reduit pas la hauteur de la fenetre quand le clavier s'ouvre :
     le champ actif peut se retrouver dessous. On le ramene dans la zone visible. */
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',function(){
      var ae=document.activeElement;
      if(!ae||!ae.closest)return;
      if(!ae.closest('#VqCodForm, #VqCartCodForm'))return;
      setTimeout(function(){
        try{ae.scrollIntoView({block:'center',behavior:'smooth'});}catch(e){}
      },120);
    });
  }

  /* Sticky order bar opens modal */
  var sb2=document.getElementById('VqStickyOrder');
  if(sb2){sb2.addEventListener('click',openModal);}

  /* Bundle offer selector: updates the hidden order fields AND every visible
     price/savings on the page (main price, savings badge, sticky bar, COD modal)
     so what the customer sees always matches what they picked. */
  var offers=document.querySelectorAll('.vq-offer');
  if(offers.length){
    var qtyField=document.getElementById('codQty');
    var hiddenProduct=document.querySelector('input[name="contact[Produit]"]');
    var baseTitle=hiddenProduct?hiddenProduct.value.split(' — ')[0]:'';
    var mainPriceEls=document.querySelectorAll('.vq-pp .vq-price__now, .vq-stickybar .vq-price__now');
    var modalPriceEl=document.querySelector('.vq-modal__pprice');
    var saveEl=document.getElementById('VqPPSave');
    offers.forEach(function(o){
      o.addEventListener('click',function(){
        offers.forEach(function(x){x.classList.remove('active');});
        o.classList.add('active');
        var q=o.getAttribute('data-qty');
        var label=o.getAttribute('data-label')||q;
        var priceEl=o.querySelector('.vq-offer__now');
        var priceText=priceEl?priceEl.textContent.trim():'';
        if(qtyField){qtyField.value=q;}
        if(hiddenProduct){hiddenProduct.value=baseTitle+(priceText?' — '+priceText:'')+' | '+label;}
        /* Le prix du palier doit voyager, sinon Make applique le prix catalogue
           x quantite : « 3 unites = 399 dh » etait facture 597 dh. Ces deux
           champs caches sont la source unique lue par le webhook ET le pixel. */
        var totalField=document.getElementById('codTotal');
        var unitField=document.getElementById('codUnit');
        var totalNum=vqMoneyToNumber(priceText);
        if(totalField&&totalNum>0){totalField.value=totalNum.toFixed(2);}
        if(unitField&&totalNum>0){unitField.value=(totalNum/(parseInt(q,10)||1)).toFixed(2);}
        if(priceText){
          mainPriceEls.forEach(function(el){el.textContent=priceText;});
          if(modalPriceEl){modalPriceEl.textContent=priceText;}
        }
        if(saveEl){
          var saveFr=o.getAttribute('data-save-fr')||'';
          var saveAr=o.getAttribute('data-save-ar')||'';
          if(saveFr){
            saveEl.hidden=false;
            saveEl.setAttribute('data-fr',saveFr);
            saveEl.setAttribute('data-ar',saveAr);
            var isAr=document.documentElement.lang==='ar';
            saveEl.textContent = isAr ? saveAr : saveFr;
          } else {
            saveEl.hidden=true;
            saveEl.textContent='';
          }
        }
      });
    });
  }

  /* ===== Info Drawer (FAQ / Livraison / CGV / Confidentialité / Contact / Centre d'aide) ===== */
  var infoDrawer=document.getElementById('VqInfoDrawer');
  if(infoDrawer){
    var infoTitle=document.getElementById('VqInfoTitle');
    var titles={
      faq:{fr:'Questions fréquentes',ar:'أسئلة متكررة',en:'Frequently Asked Questions'},
      aidefaq:{fr:"Centre d'aide",ar:'مركز المساعدة',en:'Help Center'},
      shipping:{fr:'Livraison & retours',ar:'التوصيل والإرجاع',en:'Shipping & Returns'},
      terms:{fr:'Conditions générales',ar:'الشروط العامة',en:'Terms & Conditions'},
      privacy:{fr:'Confidentialité',ar:'الخصوصية',en:'Privacy'},
      contact:{fr:'Contactez-nous',ar:'اتصل بنا',en:'Contact Us'}
    };
    function openInfo(key){
      infoDrawer.querySelectorAll('.vq-infosec').forEach(function(s){
        s.hidden = s.getAttribute('data-vq-info')!==key;
      });
      if(infoTitle&&titles[key]){
        var lg=document.documentElement.lang;
        var txt = lg==='ar' ? titles[key].ar : (lg==='en' ? titles[key].en : titles[key].fr);
        infoTitle.textContent=txt;
        infoTitle.setAttribute('data-ar',titles[key].ar);
        infoTitle.setAttribute('data-fr',titles[key].fr);
        infoTitle.setAttribute('data-en',titles[key].en);
      }
      infoDrawer.classList.add('open');
      infoDrawer.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
    }
    function closeInfo(){
      infoDrawer.classList.remove('open');
      infoDrawer.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
    }
    document.querySelectorAll('[data-vq-info-open]').forEach(function(btn){
      btn.addEventListener('click',function(){openInfo(btn.getAttribute('data-vq-info-open'));});
    });
    infoDrawer.querySelectorAll('[data-vq-info-close]').forEach(function(el){
      el.addEventListener('click',closeInfo);
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeInfo();});
    window.vqOpenInfoDrawer=openInfo;
  }

  /* ===== Header shrink on scroll + Back to top ===== */
  var header=document.querySelector('.vq-header');
  var toTop=document.getElementById('VqToTop');
  var ticking=false;
  function onScroll(){
    var y=window.scrollY||document.documentElement.scrollTop;
    if(header){header.classList.toggle('vq-scrolled',y>40);}
    if(toTop){toTop.classList.toggle('show',y>600);}
    ticking=false;
  }
  window.addEventListener('scroll',function(){
    if(!ticking){window.requestAnimationFrame(onScroll);ticking=true;}
  },{passive:true});
  onScroll();
  if(toTop){toTop.addEventListener('click',function(){window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});}
})();
(function(){
  'use strict';
  var slider=document.getElementById('VqSlider');
  if(!slider)return;
  var track=document.getElementById('VqSliderTrack');
  var slides=track?track.children:[];
  var n=slides.length;
  if(n<2)return;
  var dots=[].slice.call(document.querySelectorAll('#VqSliderDots .vq-slider__dot'));
  var bar=document.getElementById('VqSliderBar');
  var prev=document.getElementById('VqSliderPrev');
  var next=document.getElementById('VqSliderNext');
  var i=0,timer=null;
  var delay=(parseInt(slider.getAttribute('data-autoplay'),10)||6)*1000;

  function hydrate(idx){
    var slide=slides[idx];
    if(!slide)return;
    slide.querySelectorAll('[data-vq-srcset]').forEach(function(el){
      el.setAttribute('srcset',el.getAttribute('data-vq-srcset'));
      el.removeAttribute('data-vq-srcset');
    });
    slide.querySelectorAll('[data-vq-sizes]').forEach(function(el){
      el.setAttribute('sizes',el.getAttribute('data-vq-sizes'));
      el.removeAttribute('data-vq-sizes');
    });
    slide.querySelectorAll('[data-vq-src]').forEach(function(el){
      el.setAttribute('src',el.getAttribute('data-vq-src'));
      el.removeAttribute('data-vq-src');
    });
  }

  function prepareNext(){
    var task=function(){hydrate((i+1)%n);};
    if('requestIdleCallback' in window){window.requestIdleCallback(task,{timeout:2500});}
    else{window.setTimeout(task,1200);}
  }

  function go(idx){
    i=(idx+n)%n;
    hydrate(i);
    track.style.transform='translateX(-'+(i*100)+'%)';
    dots.forEach(function(d,k){d.classList.toggle('active',k===i);});
    restartBar();
    prepareNext();
  }
  function nextS(){go(i+1);}
  function prevS(){go(i-1);}

  function restartBar(){
    if(!bar)return;
    bar.classList.remove('run');bar.style.width='0';
    void bar.offsetWidth;
    bar.classList.add('run');bar.style.transitionDuration=delay+'ms';bar.style.width='100%';
  }
  function start(){
    stop();
    if(document.hidden||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    timer=setInterval(nextS,delay);
    restartBar();
  }
  function stop(){if(timer){clearInterval(timer);timer=null;}}

  if(next)next.addEventListener('click',function(){nextS();start();});
  if(prev)prev.addEventListener('click',function(){prevS();start();});
  dots.forEach(function(d){d.addEventListener('click',function(){go(parseInt(d.getAttribute('data-idx'),10));start();});});

  slider.addEventListener('mouseenter',stop);
  slider.addEventListener('mouseleave',start);

  // swipe
  var x0=null;
  slider.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;stop();},{passive:true});
  slider.addEventListener('touchend',function(e){
    if(x0===null)return;
    var dx=e.changedTouches[0].clientX-x0;
    if(Math.abs(dx)>40){dx<0?nextS():prevS();}
    x0=null;start();
  },{passive:true});

  document.addEventListener('visibilitychange',function(){document.hidden?stop():start();});

  hydrate(0);
  prepareNext();
  start();
})();
